import './index.css';

export type {SnapshotItem, SnapshotProps} from './Snapshot';
export {default as default} from './Snapshot';
